module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.posts.length === 0) ? _c('div', [_c('p', {
    staticClass: "no-posts"
  }, [_vm._v("Post is private or deleted")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('v-card', {
      key: post,
      staticClass: "mb-2"
    }, [(!_vm.platform || _vm.platform === 'instagram') ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(post.oembed)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.platform === 'tiktok') ? _c('div', [_c('div', {
      staticStyle: {
        "left": "0",
        "width": "100%",
        "height": "0",
        "position": "relative",
        "padding-bottom": "177.7778%",
        "padding-top": "90px"
      }
    }, [_c('iframe', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "left": "0px",
        "height": "100%",
        "width": "100%",
        "border": "none"
      },
      attrs: {
        "src": post,
        "allow": "fullscreen"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.platform === 'youtube') ? _c('div', {
      staticStyle: {
        "max-width": "300px",
        "max-height": "500px"
      }
    }, [_c('div', {
      staticStyle: {
        "left": "0",
        "width": "100%",
        "height": "0",
        "position": "relative",
        "padding-bottom": "100%",
        "padding-top": "90px"
      }
    }, [_c('iframe', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "left": "0px",
        "height": "100%",
        "width": "100%",
        "border": "none"
      },
      attrs: {
        "src": post,
        "allow": "fullscreen"
      }
    })])]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3baa14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InfluencerPostsModal.vue
// module id = 2146
// module chunks = 0